import { render, staticRenderFns } from "./ReadOnlyAlert.vue?vue&type=template&id=aa4ee4b8&"
import script from "./ReadOnlyAlert.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa4ee4b8')) {
      api.createRecord('aa4ee4b8', component.options)
    } else {
      api.reload('aa4ee4b8', component.options)
    }
    module.hot.accept("./ReadOnlyAlert.vue?vue&type=template&id=aa4ee4b8&", function () {
      api.rerender('aa4ee4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ReadOnlyAlert.vue"
export default component.exports